import { Component } from '@angular/core';

@Component({
	selector: 'stream-root',
	styleUrls: ['./app.component.scss'],
	template: '<router-outlet></router-outlet>'
})
export class AppComponent { }
